/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolveReservationResponse
 */
export interface ResolveReservationResponse {
    /**
     * Gondola-internal numeric booking id (as a string).
     * @type {string}
     * @memberof ResolveReservationResponse
     */
    bookingId: string;
    /**
     * User-facing booking confirmation code, for display only (nullable — not every booking has one).
     * @type {string}
     * @memberof ResolveReservationResponse
     */
    gondolaBookingId?: string | null;
    /**
     * The booking owner's user id — api_support impersonates this to call the existing booking routes.
     * @type {string}
     * @memberof ResolveReservationResponse
     */
    userId: string;
    /**
     * Payment method id — the client-side card-reveal handle (never a tokenized alias/PAN). Null for Gondola-credit bookings.
     * @type {string}
     * @memberof ResolveReservationResponse
     */
    paymentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolveReservationResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof ResolveReservationResponse
     */
    bookingProcess: string;
    /**
     * Free-text operator notes on the booking (support portal).
     * @type {string}
     * @memberof ResolveReservationResponse
     */
    notes?: string | null;
    /**
     * True when the reservation is a points redemption (total_points > 0).
     * @type {boolean}
     * @memberof ResolveReservationResponse
     */
    isPointsBooking?: boolean;
    /**
     * Support operator (Gondola user id) who hand-completed this reservation; null if not completed via the portal.
     * @type {string}
     * @memberof ResolveReservationResponse
     */
    manualBookerUserId?: string | null;
}

/**
 * Check if a given object implements the ResolveReservationResponse interface.
 */
export function instanceOfResolveReservationResponse(value: object): value is ResolveReservationResponse {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('bookingProcess' in value) || value['bookingProcess'] === undefined) return false;
    return true;
}

export function ResolveReservationResponseFromJSON(json: any): ResolveReservationResponse {
    return ResolveReservationResponseFromJSONTyped(json, false);
}

export function ResolveReservationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveReservationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
        'userId': json['user_id'],
        'paymentId': json['payment_id'] == null ? undefined : json['payment_id'],
        'status': json['status'],
        'bookingProcess': json['booking_process'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'isPointsBooking': json['is_points_booking'] == null ? undefined : json['is_points_booking'],
        'manualBookerUserId': json['manual_booker_user_id'] == null ? undefined : json['manual_booker_user_id'],
    };
}

export function ResolveReservationResponseToJSON(json: any): ResolveReservationResponse {
    return ResolveReservationResponseToJSONTyped(json, false);
}

export function ResolveReservationResponseToJSONTyped(value?: ResolveReservationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'gondola_booking_id': value['gondolaBookingId'],
        'user_id': value['userId'],
        'payment_id': value['paymentId'],
        'status': value['status'],
        'booking_process': value['bookingProcess'],
        'notes': value['notes'],
        'is_points_booking': value['isPointsBooking'],
        'manual_booker_user_id': value['manualBookerUserId'],
    };
}

